import { Stack, useTheme } from "@mui/material";

type Props = {
  children: React.ReactNode;
};

export const NotificationGroup = ({ children }: Props) => {
  const theme = useTheme();

  return (
    <Stack border={`1px solid ${theme.palette.grey[200]}`} borderRadius="12px">
      {children}
    </Stack>
  );
};
